import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgBulb(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M72 82.849c0-2.472 1.543-4.645 3.715-5.824C86.01 71.44 93 60.536 93 48c0-18.225-14.775-33-33-33S27 29.775 27 48c0 12.536 6.99 23.44 17.285 29.025C46.457 78.204 48 80.377 48 82.848V84h24v-1.151Z"
        fill="#FC0"
      />
      <path
        d="M53.2 48a2.2 2.2 0 1 0-3.771 1.54l3.771 3.772V48Zm18 0a2.2 2.2 0 0 0-4.4 0v5.312l3.771-3.772c.39-.398.63-.94.63-1.54Zm1.6 0a3.79 3.79 0 0 1-1.086 2.66l-4.784 4.784c-.043.043-.087.083-.13.122V84a.8.8 0 1 1-1.6 0V56.435a3.797 3.797 0 0 1-3.644-.99 2.2 2.2 0 0 0-3.112 0 3.797 3.797 0 0 1-3.644.99V84a.8.8 0 1 1-1.6 0V55.566c-.043-.04-.088-.08-.13-.122l-4.784-4.784A3.8 3.8 0 1 1 54.8 48v6.735c.82.397 1.833.259 2.514-.422a3.799 3.799 0 0 1 5.373 0c.68.68 1.694.82 2.513.422V48a3.8 3.8 0 1 1 7.6 0ZM33.2 48c0-1.134.07-2.251.207-3.349a.8.8 0 0 1 1.588.198A25.458 25.458 0 0 0 34.8 48a.8.8 0 1 1-1.6 0ZM60 21.2a.8.8 0 1 1 0 1.6c-9.327 0-17.47 5.066-21.83 12.6a.8.8 0 0 1-1.384-.8C41.42 26.59 50.08 21.2 60 21.2Z"
        fill="#fff"
      />
      <path d="M54.6 100.2h10.8a4.8 4.8 0 0 1-4.8 4.8h-1.2a4.8 4.8 0 0 1-4.8-4.8Z" fill="#B3C0D0" />
      <path
        d="m47.957 97.757 2.486 2.486A6 6 0 0 0 54.684 102h10.63a6 6 0 0 0 4.242-1.757l2.486-2.486A5.998 5.998 0 0 0 73.26 96H46.739a5.998 5.998 0 0 0 1.218 1.757Z"
        fill="#599F40"
      />
      <path
        d="M48 84a1.8 1.8 0 0 0-1.8 1.8v7.715A6 6 0 0 0 46.74 96H73.26a6 6 0 0 0 .54-2.485V85.8A1.8 1.8 0 0 0 72 84H48Z"
        fill="#78B441"
      />
      <path d="M67.8 95.2a.8.8 0 1 1 0 1.6H52.2a.8.8 0 1 1 0-1.6h15.6Z" fill="#007A5F" />
    </svg>
  )
}
export default wrapIllustration(SvgBulb)
